import { Component, Input } from '@angular/core';
import { Location } from '@angular/common'
import { Router } from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { PagesLoadedEvent } from 'ngx-extended-pdf-viewer';
import { StorageService } from 'src/app/services/common/storage';
@Component({
  selector: 'app-pdf',
  templateUrl: './pdf.component.html',
  styleUrls: ['./pdf.component.scss']
})
export class PdfComponent {

  public height = '100vh';
  @Input() pdfSrc;
  level;
  public year: string;
  from;
  isLevel2;
  title;

  constructor(private location: Location,public router:Router,public storage: StorageService) {

    if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state) {
      this.pdfSrc = this.router.getCurrentNavigation().extras.state.url;
      this.level = this.router.getCurrentNavigation().extras.state.level;
      this.from = this.router.getCurrentNavigation().extras.state.from;
      this.isLevel2 = this.router.getCurrentNavigation().extras.state.isLevel2;
      this.title = this.router.getCurrentNavigation().extras.state.title;
      this.storage.setItem("url",this.pdfSrc);
      this.year = this.router.getCurrentNavigation().extras.state.year;

    }
    else{
      
      this.initialise();

      

    }
  }
  async initialise() {
    const state = history.state;
    this.pdfSrc =  await this.storage.getItem("url");
    this.level = await this.storage.getItem("level");
    this.year = state.year;
    this.from = await this.storage.getItem("from");
    this.isLevel2 = await this.storage.getItem("isLevel2");
  }

  public gotoLevel(){
  
    this.router.navigate([`/student/lessons`], { state: { level: this.level , year:  this.year} });
    this.location.back();
  }

  public home(){
    this.router.navigate(['/']);
  }


  ngOnInit(): void{

     }
}
